module.exports = __webpack_public_path__ + "img/1.d2401d92.png";